import axios from "axios";
import React, { useEffect, useState, useCallback } from "react";
import moment from "moment";
import {
  AESEncryption,
  ApiResDecrypt,
  checkDateRange,
  compareDate,
  decryptData,
  encryptData,
  noDataFound,
} from "../../../CommonMethhods/CommonMethods";
import { Dashboard_Client_Report } from "../../../Configuration/API_URL";
import SmallLoader from "../../../Components/Common/smallLoader";
import { Constants } from "../../../CommonMethhods/Constants";
import Loader from "../../../Components/Common/Loader";
import MTFDetailsTable from "../../../Components/ReportTables/MTFDetailsTable";
import FromdateComponent from "../../Reports/FromdateComponent";
import TodateComponent from "../../Reports/TodateComponent";
import { toast } from "react-toastify";
import { Partner_Reports } from "../../../Configuration/Partner_URL";
import DurationChangeComponent from "../../Reports/DurationChangeComponent";

function MTFDetailsNew() {
  const storeToken = localStorage.getItem("ssoToken");
  const partnerSsoToken = localStorage.getItem("partnerSsoToken");
  const partnerRoleNew = localStorage.getItem("partnerRoleNew");
  const [fileType, setFileType] = useState("grid");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [gridVal, setGridVal] = useState([]);
  const [loader, setLoader] = useState(false);
  const [smallLoaderExcel, setSmallLoaderExcel] = useState(false);
  const [smallLoaderPdf, setSmallLoaderPdf] = useState(false);
  const [error, setError] = useState("");
  const [noReportFound, setNoReportFound] = useState(false);
  const [customShow, setCustomShow] = useState(false);
  const ClientId2 = localStorage.getItem("ClientId2");


  if (toDate === "" || fromDate === "") {
    // const current = new Date();
    // const CurrentYear = current.getFullYear();
    // const CurrentMonth = current.getMonth();
    // if (CurrentMonth < 4) {
    //   const newYear = `04-01-${CurrentYear - 1}`;
    //   const date = `${current.getMonth() + 1
    //     }-${current.getDate()}-${current.getFullYear()}`;
    //   const date1 = moment(date, "MM-DD-YYYY").format("MM-DD-YYYY");
    //   setFromDate(newYear);
    //   setToDate(date1);
    // } else {
    //   const newYear = `04-01-${CurrentYear}`;
    //   const date = `${current.getMonth() + 1
    //     }-${current.getDate()}-${current.getFullYear()}`;
    //   const date1 = moment(date, "MM-DD-YYYY").format("MM-DD-YYYY");
    //   setFromDate(newYear);
    //   setToDate(date1);
    // }
    let date = new Date();
    let firstDay = "";
    let lastDay = "";
    let firstVal = new Date(date.getFullYear(), date.getMonth(), 1);
    firstDay = moment(firstVal, "MM-DD-YYYY").format("MM-DD-YYYY");
    let lastVal = new Date();
    lastDay = moment(lastVal, "MM-DD-YYYY").format("MM-DD-YYYY");
    setFromDate(firstDay)
    setToDate(lastDay)
  }

  const getMTFReport = useCallback(async (clientCode) => {
      setLoader(fileType === "grid");
      setSmallLoaderExcel(fileType === "excel");
      setSmallLoaderPdf(fileType === "pdf");

      const payloadValue = {
        clientCode,
        fromDate,
        toDate,
        fileType,
        seg: "stocks",
      };
      const encPayload = AESEncryption(payloadValue);

      try {
        const response = await axios.post(
          Dashboard_Client_Report.MTFDetail_URL,
          `"${encPayload}"`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${partnerRoleNew === "Partner" ? partnerSsoToken : storeToken}`,
              reserv: 1,
            },
          }
        );
        const res = ApiResDecrypt(response.data);

        if (res?.status === 0) {
          if (fileType === "grid") {
            setNoReportFound(false);
            setGridVal(res.data.mtfDetails);
          } else {
            window.open(
              res.data,
              fileType === "pdf" ? "_blank" : "_self",
              "noopener,noreferrer"
            );
          }
        } else {
          if (fileType === "grid") {
            setGridVal([]);
            setNoReportFound(res.message);
          } else {
            toast.error(res.message);
          }
        }
      } catch (error) {
        if (fileType === "grid") {
          toast.error(error.message);
        } else {
          setGridVal([]);
          setNoReportFound(error.message);
        }
      } finally {
        setLoader(false);
        setSmallLoaderExcel(false);
        setSmallLoaderPdf(false);
      }
    },
    [fileType, fromDate, toDate, storeToken]
  );

  useEffect(() => {
    const clientCode = localStorage.getItem("clientCode");
    if (
      (clientCode || ClientId2) &&
      fileType &&
      compareDate(fromDate) &&
      compareDate(toDate) &&
      checkDateRange(fromDate, toDate)
    ) {
      getMTFReport((clientCode || ClientId2));
    } else {
      setGridVal([]);
    }
  }, [fileType, fromDate, toDate, getMTFReport]);

  const handleFromDateChange = useCallback((e) => {
    const date = moment(e.target.value, "YYYY-MM-DD").format("MM-DD-YYYY");
    setFromDate(date);
    setError("");
    setGridVal([]);
    setFileType("");
    setNoReportFound(false);
  }, []);

  const handleToDateChange = useCallback((e) => {
    const date = moment(e.target.value, "YYYY-MM-DD").format("MM-DD-YYYY");
    setToDate(date);
    setError("");
    setGridVal([]);
    setFileType("");
    setNoReportFound(false);
  }, []);

  const handleOnClick = useCallback(
    (e) => {
      if (fromDate && toDate && e.target.value) {
        if (
          compareDate(fromDate) &&
          compareDate(toDate) &&
          checkDateRange(fromDate, toDate)
        ) {
          setFileType(e.target.value);
          setError("");
        } else {
          setError("Please Select Correct Date.");
        }
      }
    },
    [fromDate, toDate]
  );

  function formatDate(date) {
    return moment(date, "MM-DD-YYYY").format("YYYY-MM-DD");
  }

  const currentDate = new Date();
  const yyyy = currentDate.getFullYear();
  let mm = currentDate.getMonth() + 1;
  let dd = currentDate.getDate();
  if (dd < 10) dd = "0" + dd;
  if (mm < 10) mm = "0" + mm;
  const FormatedDate = dd + "/" + mm + "/" + yyyy;
  const DateReverse = FormatedDate.split("/").reverse().join("-");

  const onChangeDuration = () => {
    setError("");
    setGridVal([]);
    setFileType("");
    setNoReportFound(false);
  }
  return (
    <>
      <div
        className="tab-pane fade show active"
        id="mtf-details"
        role="tabpanel"
        aria-labelledby="mtf-details"
      >
        <div className="reports-date-filter">
          <div className="reports-left-form">
            <form>
              <div className="report-form-wrapper">
                <div className="form-group">
                  <DurationChangeComponent
                    setCustomShow={setCustomShow}
                    setFromDate={setFromDate}
                    setToDate={setToDate}
                    className="report-custom-select"
                    onChangeDuration={onChangeDuration}
                    screen="Client Dashboard"
                  />
                </div>
                {customShow && <FromdateComponent
                  fromDate={handleFromDateChange}
                  formatDate={formatDate(fromDate)}
                  DateReverse={DateReverse}
                />}
                {customShow && <TodateComponent
                  toDate={handleToDateChange}
                  formatToDate={formatDate(toDate)}
                  DateReverse={DateReverse}
                  errorResponse={error}
                />}
              </div>
            </form>
            <button
              className="generate-button get-data"
              value="grid"
              onClick={handleOnClick}
            >
              {Constants.Submit}
            </button>
          </div>
          <div className="report-btn-wrapper">
            <button
              className="generate-button excel-btn"
              value="excel"
              onClick={handleOnClick}
            >
              {smallLoaderExcel ? (
                <SmallLoader />
              ) : (
                <>
                  <span className="icon-excelsvg"></span>
                  {Constants.Excel}
                </>
              )}
            </button>
            <button
              className="generate-button pdf-btn"
              value="pdf"
              onClick={handleOnClick}
            >
              {smallLoaderPdf ? (
                <SmallLoader />
              ) : (
                <>
                  <span className="icon-pdfsvg"></span>
                  {Constants.PDF}
                </>
              )}
            </button>
          </div>
        </div>
      </div>
      {loader ? (
        <div className="loader-alignment">
          <Loader />
        </div>
      ) : gridVal.length > 0 ? (
        <MTFDetailsTable gridVal={gridVal} />
      ) : (
        noReportFound && (
          <h4 className="report-error-message">{noDataFound(noReportFound)}</h4>
        )
      )}
    </>
  );
}

export default MTFDetailsNew;
